import React from 'react'
import styled from 'styled-components'
import { Button, Colors, Modal, Display, Select ,SelectSearch, DatePicker, TextInput} from 'advenio-components'
import { Form } from 'formsy-react-2'
import PropTypes from 'prop-types'
import moment from 'moment'
import isSameDay from 'react-dates/lib/utils/isSameDay'
import LoadingSpinner from '../LoadingSpinner'
import { stringContainsAnyOf } from '../../utils/Utils'

const WarningZone = styled.div`
  flex:1;
  justify-content: flex-start;
  display: flex;
  background: ${Colors.yellow100};
  flex-direction: column;
  color:${Colors.yellowText};
  padding: 16px;
  h3 {
    margin:0;
    margin-bottom: 16px;
  }
`
const WarningRow = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
  }

`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
  overflow: ${props => props.parent ? 'auto' : 'none'};;
`
const Text = styled(Display)`
  color: ${Colors.gray700};
  margin-bottom: 16px;
  text-align: center;
  margin-top: -32px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 32px;
`
const ModalResservationB2B = ({
    isOpen
    ,onClose
    ,typeModal
    ,loading
    ,loadingSelect
    ,loadingOptCompany
    ,loadingOptStudent
    ,studentOptions
    ,companyOptions
    ,centersOptions
    ,changeDate
    ,changeStudents
    ,changeCompany
    ,typeOptions
    ,onSubmit
    ,center_id
    ,reservationId
    ,student_id
    ,parent_id
    ,company_id
    ,reservation_date
    ,type_id
    ,isParent
  }) => (
  <Modal
    isOpened={isOpen}
    onClose={onClose}
    headerTitle={`${typeModal} Reservación`}
    // loading={loadingPayments}
  >
    <Container parent={isParent}>
      <Form
        onValidSubmit={onSubmit}
        // onInvalid={validateForm}
      >
       {typeModal === 'Cancelar' ? <Text>¿Seguro que deseas <b>Cancelar</b>?</Text>:null}
       {!isParent && (
       loadingOptCompany ?
         <LoadingSpinner containerHeight={100} size={25} />:
         <SelectSearch
           label={"Selecciona un Compañía"}
           name={"company_id"}
           options={companyOptions}
           disabled={companyOptions.length === 0 || !!stringContainsAnyOf(typeModal,['Cancelar','Autorizar'])}
           required
           onSelectCallback={changeCompany}
           value={company_id}
         />
       )} 
        {!isParent &&(
          loadingOptStudent ?
          <LoadingSpinner containerHeight={100} size={25} />:
          <SelectSearch
            label={"Selecciona un Alumno"}
            name={"student_id"}
            options={studentOptions}
            // onSelectCallback={changeStudents}
            required
            disabled={ studentOptions.length === 0 || !!stringContainsAnyOf(typeModal,['Cancelar','Autorizar'])}
            value={student_id}
          />
        )}
         <DatePicker
          name="reservation_date"
          label="Fecha"
          pickerType="single"
          hideEmptyHelpBlock
          disableBeforeToday
          value={reservation_date}
          onDateChange={(reservation_date)=>changeDate(reservation_date)}
          disabled={!!stringContainsAnyOf(typeModal,['Cancelar','Autorizar'])}
          />
          {isParent ? (
          <Select
            label={"Selecciona un Centro"}
            name={"center_id"}
            options={centersOptions}
            // onSelectCallback={changeStudents}
            required
            disabled={ !!stringContainsAnyOf(typeModal,['Cancelar','Autorizar'])}
            value={center_id}
          />):
          <div style={{display:'none'}}>
            <TextInput
              name="center_id"
              value={center_id}
              type="hidden"
            />
          </div>
          }
        <Select
          label={"Selecciona un Turno"}
          name={"reservation_type"}
          options={typeOptions}
          loading={loadingSelect}
          disabled={typeOptions.length === 0|| !!stringContainsAnyOf(typeModal,['Cancelar','Autorizar'])}
          value={type_id}
          // emptyElement
          required
        />
        <div style={{display:'none'}}>
          <TextInput
            name="modalType"
            value={typeModal}
            type="hidden"
          />
        </div>
         {/* <DateTimePicker
            name="date_time"
            hideEmptyHelpBlock
            disableBeforeToday
            value={moment().format('YYYY-MM-DD')}
            hour={moment().format('HH:mm')}
          /> */}
       {/* {(typeModal === 'cancel')&& (
          <WarningZone>
          <h3>Aviso</h3>
          <WarningRow>
            <div>
            {typeModal === 'cancel' && (<span>Si se cancela no se podra reactivar esta reservación.</span>)}
            </div>
          </WarningRow>
        </WarningZone>
       )} */}
        <ButtonContainer>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            primary
            loading={loading}
            type="submit"
          >
            {!!stringContainsAnyOf(typeModal,['Cancelar','Nueva']) ? "Guardar": typeModal}
          </Button>
        </ButtonContainer>
      </Form>
    </Container>
  </Modal>
)

ModalResservationB2B.propTypes = {
  /** Callback function to be fired when submitting the form */
  handleSubmit: PropTypes.func,
  /** Indicates if the modal should be open or not */
  isOpen: PropTypes.bool,
  /** Indicates if the charge is in the process of being deleted */
  loading: PropTypes.bool.isRequired,
  /** Callback function to be fired when closing the modal */
  onClose: PropTypes.func.isRequired,
}

ModalResservationB2B.defaultProps = {
  isOpen: false,
  loading:false,
  typeModal: 'Nueva',
}

export default ModalResservationB2B



// WEBPACK FOOTER //
// ./src/Components/ReservationB2b/ModalResservationB2B.jsx